import RectangleToolIcon from "../../media/RectangleToolIcon";
import LassoToolIcon from "../../media/LassoToolIcon";
import CircleToolIcon from "../../media/CircleToolIcon";

export type MapStyle = keyof typeof MAP_STYLES;

export type MapViewOptions = {
    zoom: number;
    center: [number, number]; // [lng., lat.]
};

type ThermalCapacityThreshold = {
    value: number;
    label: string;
    color: string;
};

type ThermalCapacityCluster = {
    name: string;
};

// Initial map center in [longitude, latitude]
export const INITIAL_MAP_POSITION: MapViewOptions = {
    zoom: 3.5,
    center: [-96.34, 39.34],
};

export const MAP_STYLES = {
    Street: "mapbox://styles/mapbox/streets-v12",
    Satellite: "mapbox://styles/mapbox/satellite-v9",
    Dark: "mapbox://styles/mapbox/navigation-night-v1",
    Light: "mapbox://styles/mapbox/navigation-day-v1",
    Outdoors: "mapbox://styles/mapbox/outdoors-v12",
} as const;

export const THERMAL_CAPACITY_THRESHOLDS: ThermalCapacityThreshold[] = [
    { value: 225, label: ">225", color: "#D00131" },
    { value: 175, label: "175", color: "#D21C00" },
    { value: 125, label: "125", color: "#E87200" },
    { value: 75, label: "75", color: "#FFBC3C" },
    { value: 50, label: "50", color: "#FFE066" },
    { value: 30, label: "30", color: "#FFFFBF" },
    { value: 20, label: "20", color: "#B1F3F8" },
    { value: 10, label: "10", color: "#8FC6D7" },
    { value: 0, label: "0", color: "#5FA1C7" },
    { value: -20, label: "-20", color: "#4280B9" },
    { value: -40, label: "<-40", color: "#062A78" },
];

export const THERMAL_CAPACITY_CLUSTER_TYPES: ThermalCapacityCluster[] = [
    {
        name: "Cluster Injection",
    },
    {
        name: "Single Injection",
    },
];

interface SelectionToolIconProps {
    fillClassName: string;
}

type SelectionToolConfig = {
    id: string;
    icon: React.ComponentType<SelectionToolIconProps>;
};

export const selectionTools: SelectionToolConfig[] = [
    {
        id: "Rectangle",
        icon: RectangleToolIcon,
    },
    {
        id: "Lasso",
        icon: LassoToolIcon,
    },
    {
        id: "Circle",
        icon: CircleToolIcon,
    },
];
